import SmallFeatureCard from "@/components/Features/components/SmallFeatureCard";
import Section from "@/components/Section";
import { otherFeaturesData } from "@/utils/staticData/dataConstants";
import { Grid, Typography } from "@mui/material";

const OtherFeaturesSection = () => {
  return (
    <Section pt={{ xs: 7.5, lg: 12.5 }} pb={{ xs: 0, lg: 12.5 }}>
      <Typography variant="h2" sx={{ marginBottom: "40px" }}>
        Additional Features
      </Typography>
      <Grid container spacing={2}>
        {otherFeaturesData.map((data, index) => (
          <Grid item xs={12} md={4} key={index}>
            <SmallFeatureCard
              title={data.title}
              description={data.description}
              imageUrl={data.imageUrl}
            />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default OtherFeaturesSection;
